import React, { createContext, useContext, useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_API_BASE}/chatHub`, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect()
      .build();

    conn.start()
      .then(() => console.log("Notifications: connected to SignalR"))
      .catch(err => console.error("Notification Hub error:", err));

    /** MESSAGE notification */
    conn.on("NewNotification", (notif) => {
      const formatted = {
        type: "message",
        conversationId: notif.conversationId,
        contentPreview: notif.contentPreview,
        timestamp: notif.timestamp,
      };

      setNotifications(prev => [formatted, ...prev]);
      setUnreadCount(prev => prev + 1);
    });

    /** NEW ANNOUNCEMENT notification */
    conn.on("NewAnnouncementNotification", (notif) => {
      const formatted = {
        type: "new-announcement",
        roomId: notif.roomId,
        contentPreview: notif.contentPreview,
        timestamp: notif.timestamp,
      };

      setNotifications(prev => [formatted, ...prev]);
      setUnreadCount(prev => prev + 1);
    });

    return () => conn.stop();
  }, []);

  /** Mark all notifications as read */
  function markAllAsRead() {
    setUnreadCount(0);
  }

  /** notifications leeren */
  function clearNotifications() {
    setNotifications([]);
    setUnreadCount(0);
  }

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        unreadCount,
        markAllAsRead,
        clearNotifications,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

/** Hook */
export function useNotifications() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotifications must be used inside <NotificationProvider>");
  }
  return context;
}
